import type { NotificationActionPayload } from '@erp/shared-types';
import { NotificationActionButtons } from './NotificationActions';
import { isWorkflowRunHref } from './notificationLinks';
import { NotificationViewRunButton } from './NotificationViewRunButton';

interface Props {
  link: string | null;
  actions: NotificationActionPayload[];
  onViewRun?: () => void;
}

/**
 * Action row under a notification: View Run when the deep link is a workflow
 * run, plus any payload-defined RPC buttons (e.g. Re-run workflow).
 */
export function NotificationItemActions({ link, actions, onViewRun }: Props) {
  const showViewRun = link !== null && isWorkflowRunHref(link);
  if (!showViewRun && actions.length === 0) return null;

  return (
    <div className="mb-2 ml-14 mr-3 flex flex-wrap gap-1.5">
      {showViewRun && link && (
        <NotificationViewRunButton href={link} onClick={onViewRun} />
      )}
      {actions.length > 0 && (
        <NotificationActionButtons
          actions={actions}
          className="flex flex-wrap gap-1.5"
        />
      )}
    </div>
  );
}
